// Helper function to get current logged-in user ID from localStorage
export const getCurrentUserId = (): string | null => {
  try {
    // First try to get from profile (user info stored after login)
    const profile = localStorage.getItem('profile');
    if (profile) {
      const userProfile = JSON.parse(profile);
      const userId =
        userProfile.id || userProfile.userId || userProfile.user_id;
      if (userId) return String(userId);
    }

    // Fallback: try to decode JWT token
    const token = localStorage.getItem('token');
    if (token) {
      const parts = token.split('.');
      if (parts.length === 3) {
        const payload = JSON.parse(atob(parts[1]));
        const userId =
          payload.sub || payload.userId || payload.id || payload.user_id;
        if (userId) return String(userId);
      }
    }

    return null;
  } catch (error) {
    console.error('Error getting current user ID:', error);
    return null;
  }
};

// Helper function to get current user info
export const getCurrentUserProfile = () => {
  try {
    const profile = localStorage.getItem('profile');
    if (profile) {
      return JSON.parse(profile);
    }
    return null;
  } catch (error) {
    console.error('Error getting current user profile:', error);
    return null;
  }
};
